<template>
  <div class="similar-query">
    <h2>相似问题</h2>
    <ul class="list-content">
      <div
        class="list-item"
        v-for="(item, index) in list"
        :key="item.id"
        @click="toDetail(item.id)"
      >
      <!-- 只显示5条相似问题 -->
       <li v-if="index<5">
          <p class="title" :title="item.title">{{ item.title }}</p>
       </li>
      </div>
    </ul>
  </div>
</template>
<script>
export default {
  name: "similar-query",
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    toDetail(id) {
      this.$emit("toDetail", id);
      console.log(id);
    },
  }
};
</script>
<style scoped>
.similar-query h2 {
  margin-left: 1em;
  margin-bottom: 30px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 20px;
  color: #000000;
  letter-spacing: 0;
}
.list-content {
  list-style-type: disc;
  margin-left: 0;
}
.list-item {
  color: #1f85ec;
  margin-bottom: 20px;
  cursor: pointer;
}
.list-item .title {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #111111;
  letter-spacing: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list-item .title:hover {
  color: #1f85ec;
}
</style>